import axios from '../../functions/axios';
import { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { parseDate } from '../../functions/functions';
import { useAuthContext } from '../../hooks/useAuthContext';
import { FormControl, Box, Tab, Tabs, Typography, Grid, CircularProgress, Stack, Pagination, InputLabel, Select, MenuItem } from '@mui/material';
import { DatePicker, Localization } from 'react-widgets';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';
const InvoiceList = (props) => {
  const [invoiceStatus, setInvoiceStatus] = useState('ALL');
  const [page, setPage] = useState(1);
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [apiData, setApiData] = useState(null);
  const { user } = useAuthContext();

  const onInvoicePaymentChange = async (event, carriage) => {
    const checkboxState = !!event.target.checked;
    const confirmBox = window.confirm(checkboxState ? 'Płatność zaksięgowana?' : 'Usunąć płatność?');
    if (!confirmBox) return;

    const response = await axios
      .patch(`/carriage`, {
        _id: carriage._id,
        invoicePay: checkboxState,
      })
      .catch(console.log);

    const carriages = apiData.carriages.reduce((acc, value) => {
      if (value._id === response.data._id) {
        return [
          ...acc,
          {
            ...value,
            invoiceStatus: response.data.invoiceStatus,
            invoicePay: response.data.invoicePay,
          },
        ];
      }
      return [...acc, value];
    }, []);

    setApiData({
      ...apiData,
      carriages,
    });
  };

  useEffect(() => {
    if (!user) return;
    const controller = new AbortController();
    const { signal } = controller;

    (async () => {
      try {
        const response = await axios.get('/invoices', {
          signal,
          params: {
            invoiceStatus,
            page,
            dateStart,
            dateEnd,
          },
        });

        setApiData(response.data);
      } catch (err) {
        console.log(err);
      }
    })();
  }, [page, invoiceStatus, user, dateStart, dateEnd]);

  if (!apiData) return null;

  return (
    <Box style={{ margin: '2em' }}>
      <Box style={{ display: 'flex', alignItems: 'center' }}>
      <FormControl style={{ width: '250px' }}>
        <InputLabel>Wybierz status</InputLabel>
        <Select
          value={invoiceStatus}
          label='Wybierz status'
          onChange={(event, value) => {
            setInvoiceStatus(event.target.value);
            setPage(1);
          }}
        >
          <MenuItem value={'ALL'}>Wszystkie</MenuItem>
          <MenuItem value={'CLOSE_DEADLINE'}>Bliski termin płatności</MenuItem>
          <MenuItem value={'OVERDUE'}>Nie opłacone</MenuItem>
          <MenuItem value={'PAID'}>Opłacone</MenuItem>
        </Select>
      </FormControl>
      {invoiceStatus === 'ALL' && (
        <Box style={{ display: 'flex', margin: '0 25px', alignItems: 'center', gap: '10px' }}>
          <Localization
            date={
              new DateLocalizer({
                culture: 'pl-PL',
                firstOfWeek: 1,
              })
            }
          >
            <DatePicker
              value={dateStart}
              valueEditFormat={{ dateStyle: 'long' }}
              valueDisplayFormat={{ dateStyle: 'long' }}
              placeholder='Od'
              onChange={(value) => {
                setDateStart(parseDate(value).day);
              }}
            />
          </Localization>
          <b style={{ margin: '0 10px' }}>-</b>
          <Localization
            date={
              new DateLocalizer({
                culture: 'pl-PL',
                firstOfWeek: 1,
              })
            }
          >
            <DatePicker
              value={dateEnd}
              valueEditFormat={{ dateStyle: 'long' }}
              valueDisplayFormat={{ dateStyle: 'long' }}
              placeholder='Do'
              onChange={(value) => {
                setDateEnd(parseDate(value).day);
              }}
            />
          </Localization>
        </Box>
      )}
      </Box>
      <br />
      <br />
      {Array.isArray(apiData.carriages) && apiData.carriages.length === 0 && <Box style={{ display: 'flex', justifyContent: 'center' }}>Brak faktur...</Box>}
      {Array.isArray(apiData.carriages) && apiData.carriages.length !== 0 && (
        <>
          <Grid container>
            <Grid item xs={1} style={{ textAlign: 'center' }}>
              Nr faktury
            </Grid>
            <Grid item xs={2} style={{ textAlign: 'center' }}>
              Kontrahent
            </Grid>
            <Grid item xs={2} style={{ textAlign: 'center' }}>
              Kwota
            </Grid>
            <Grid item xs={2} style={{ textAlign: 'center' }}>
              Data transportu
            </Grid>
            <Grid item xs={2} style={{ textAlign: 'center' }}>
              Termin płatności
            </Grid>
            <Grid item xs={2} style={{ textAlign: 'center' }}>
              Nr rejestracyjny
            </Grid>
            <Grid item xs={1} style={{ textAlign: 'center' }}>
              Opłacono
            </Grid>
          </Grid>
          {apiData.carriages.map((carriage) => {
            const invoicePaymentStatusColor = (() => {
              if (carriage.invoicePay) return '10px solid green';
              switch (carriage.invoiceStatus) {
                case 'PAID':
                  return '10px solid green';
                case 'CLOSE_DEADLINE':
                  return '10px solid yellow';
                case 'OVERDUE':
                  return '10px solid red';
                default:
                  return '10px solid #636363';
              }
            })();

            return (
              <Grid
                container
                key={carriage.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: '10px 0',
                  border: '1px solid gray',
                  minHeight: '50px',
                  borderRight: invoicePaymentStatusColor,
                  borderRadius: '10px',
                  backgroundColor: '#3d3d3d',
                }}
              >
                <Grid item xs={1} style={{ textAlign: 'center' }}>
                  {carriage.invoice}
                </Grid>
                <Grid item xs={2} style={{ textAlign: 'center' }}>
                  {carriage.client?.companyName}
                </Grid>
                <Grid item xs={2} style={{ textAlign: 'center' }}>
                  {carriage.cost} {carriage.currency}
                </Grid>
                <Grid item xs={2} style={{ textAlign: 'center' }}>
                  {carriage.day ? new Date(carriage.day).toLocaleDateString('pl') : null}
                </Grid>
                <Grid item xs={2} style={{ textAlign: 'center' }}>
                  {carriage.invoiceDate ? new Date(carriage.invoiceDate).toLocaleDateString('pl') : null}
                </Grid>
                <Grid item xs={2} style={{ textAlign: 'center' }}>
                  {carriage.car?.plate}
                </Grid>
                <Grid item xs={1} style={{ textAlign: 'center' }}>
                  <input type='checkbox' checked={carriage.invoicePay} onChange={(event) => onInvoicePaymentChange(event, carriage)} />
                </Grid>
              </Grid>
            );
          })}
        </>
      )}
      <br />
      {apiData?.pagination?.totalPages > 1 && (
        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Stack spacing={2}>
            <Pagination
              page={page}
              count={apiData?.pagination?.totalPages}
              onChange={(event, value) => {
                setPage(value);
              }}
              color='primary'
            />
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default InvoiceList;
